export default "__VITE_ASSET__cef974e5__"